import Logger, {
  EventModel,
  EventName,
  LogLevel,
  ProviderType
} from '@/wrappers/logger'

const useCertificateLog = () => {
  const addLogOnPublishTask = (
    personId: string,
    model: EventModel,
    taskType?: string,
    modelId?: string,
    token?: string
  ) => {
    Logger.addLog(
      EventName.CERTIFICATION_INTERACTION,
      {
        model,
        modelId,
        personId,
        data: {
          context: taskType,
          action: 'publish-tasks',
          value: !!token
        }
      },
      {
        isAction: true,
        logLevel: LogLevel.INFO
      },
      [ProviderType.DATADOG]
    )
  }
  return {
    addLogOnPublishTask
  }
}

export default useCertificateLog
